import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {routeNodeSelector, actions as routerActions} from 'redux-router5';
import PropTypes from 'prop-types';

import {userActions} from 'actions';

import {Loading} from 'Common/Structure';

const AuthenticateToken = props => {
  useEffect(
    () => {
      if (!props.route.params.type || !props.route.params.id) {
        props.navigateTo('error', {
          title: 'Authorization Error',
          error: 'Missing payment information',
        });
      } else {
        load();
      }
    },
    [props.route.params.token],
  );

  const load = async () => {
    const success = await props.loadGuestToken(props.route.params);
    if (success) {
      if (props.route.params.type && props.route.params.id) {
        props.navigateTo('payment', {
          type: props.route.params.type,
          id: props.route.params.id,
        });
        return;
      }
    }
    props.navigateTo('error', {
      title: 'Unauthorized',
      error: 'Authentication error',
    });
  };

  return <Loading />;
};

AuthenticateToken.defaultProps = {
  route: {},
};

AuthenticateToken.propTypes = {
  route: PropTypes.shape(),

  // functions
  loadGuestToken: PropTypes.func.isRequired,
  navigateTo: PropTypes.func.isRequired,
};

const mapStateToProps = state => {
  return {
    ...routeNodeSelector('authenticate')(state),
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      loadGuestToken: userActions.loadGuestToken,
      navigateTo: routerActions.navigateTo,
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AuthenticateToken);



// WEBPACK FOOTER //
// ./src/paymentApp/AuthenticateToken.js